import { defineMessages } from 'react-intl';

export default defineMessages({
  relayPointWithoutSelectionDidactics: {
    id: 'components.myaccount.claims.handling.pickup.relayPointWithoutSelectionDidactics',
    defaultMessage: 'Drop off your parcel at the relay point of your choice',
  },
  deductibleFromRefund: {
    id: 'view.addressHandling.deductibleFromRefund',
    defaultMessage: 'deductible from refund',
  },
});
